export default "__VITE_ASSET__DMN9psOV__"